// Jump directly to a section's top (no smooth scrolling) accounting for the fixed header.
export function ao3ScrollToSection(targetId: string) {
  const el = document.getElementById(targetId);
  if (!el) return;
  const header = document.getElementById("ao3-header");
  const offset = header ? header.offsetHeight : 0;
  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(top, 0), behavior: "auto" });
}